import { AlertState } from "global/AlertState";
import { AuthCheckedState } from "global/AuthCheckedState";
import { LoginActiveView } from "global/LoginActiveView";
import { RoleState } from "global/RoleState";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { LoginState } from "../global/LoginState";
import { UserState } from "../global/UserState";
import sessionCheck from "./SessionCheck";

const TokenChecker = () => {
  const [loginState, setLoginState] = useRecoilState(LoginState); // ← read loginState too
  const [, setAlertMessage] = useRecoilState(AlertState);
  const [, setUserState] = useRecoilState(UserState);
  const [, setRoleState] = useRecoilState(RoleState);
  const setAuthChecked = useSetRecoilState(AuthCheckedState);
  const setLoginView = useSetRecoilState(LoginActiveView);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [loginState]);

  const fetchData = async () => {
    try {
      const response = await sessionCheck(
        `/auth/data`,
        "GET",
        null,
        false,
        true,
        setAlertMessage,
        navigate,
        setLoginState,
      );

      if (response?.success) {
        const body = response?.body?.body;

        if (body?.hasPasswordChanged === false) {
          setLoginState(true);
          setLoginView("change-password");
          navigate("/change-password", { replace: true });
        } else {
          const userRole = body?.role;
          setRoleState(userRole);
          setLoginState(true);
          setUserState({
            username: body?.username,
            hasPasswordChanged: body?.hasPasswordChanged,
            role: body?.role,
          });

          const currentPath = window.location.pathname;
          if (currentPath === "/" || currentPath === "/login") {
            if (userRole === "SuperAdmin") navigate("/departments", { replace: true });
            else if (userRole === "Admin") navigate("/officer-list", { replace: true });
            else if (userRole === "NodalOfficer") navigate("/loans", { replace: true });
          }
        }
      } else {
        setLoginState(false);
        setRoleState(null);
      }
    } finally {
      setAuthChecked(true);
    }
  };

  return null;
};

export default TokenChecker;